export const EXTENSION_TYPE_NAME = 'da-gallery';

//# sourceMappingURL=constants.js.map